// GAVION A10: Profile → "Change password" (in place, no email).
export const profilePasswordEn = {
  button: "Change password",
  title: "Change password",
  new_password: "New password",
  confirm_password: "Confirm password",
  hint: "At least %{min} characters.",
  cancel: "Cancel",
  save: "Save",
  success: "Password updated.",
  microsoft_only:
    "You sign in with Microsoft: your password is managed in Microsoft 365.",
  errors: {
    too_short: "The password must be at least %{min} characters long.",
    mismatch: "The passwords do not match.",
    same_password: "Choose a password different from the current one.",
    weak_password: "Password too weak. Choose a longer or less common one.",
    reauthentication_needed:
      "For security, sign out and sign back in before changing your password.",
    session_expired: "Your session has expired. Sign in again and retry.",
    unknown: "The password could not be changed. Please try again.",
  },
};
